import {
  FaUsers,
  FaClipboardCheck,
  FaTable,
  FaAward,
  FaMedal,
  FaDumbbell,
  FaTrophy,
  FaCalendarAlt,
  FaStar,
  FaBullseye,
  FaTasks,
  FaBookOpen,
  FaBalanceScale,
} from "react-icons/fa";

export const HELP_CATEGORIES = [
  "Adhérents",
  "Présences",
  "Grades",
  "Compétitions",
  "Préparation",
  "Organisation",
  "Ressources",
];

export const TEACHER_HELP_ITEMS = [
  {
    id: "listing-adherents",
    title: "Listing Adhérents",
    category: "Adhérents",
    icon: FaUsers,
    color: "from-sky-500 to-indigo-500",
    shortDescription:
      "Retrouver rapidement un adhérent, consulter sa fiche, ses coordonnées, ses groupes et ses informations utiles.",
    searchTags: [
      "adhérent",
      "profil",
      "fiche",
      "coordonnées",
      "photo",
      "groupes",
      "licence",
      "parents",
      "email",
      "téléphone",
    ],
    steps: [
      "Ouvrez le listing pour rechercher un adhérent par nom, prénom ou groupe.",
      "Touchez sa photo ou sa carte pour ouvrir sa fiche détaillée.",
      "Consultez les informations importantes : coordonnées, représentant légal, année de naissance, catégorie d’âge et de poids.",
      "Utilisez la fiche pour retrouver rapidement les informations utiles au suivi sportif ou administratif.",
    ],
    quickActions: [
      "Retrouver une fiche adhérent",
      "Vérifier les coordonnées",
      "Contrôler la catégorie d’âge",
      "Consulter les groupes de pratique",
    ],
    tips: [
      "Utilisez cette page avant une compétition pour vérifier âge, poids et licence.",
      "En cas d’urgence, la fiche adhérent reste le meilleur point d’entrée pour retrouver les informations de contact.",
      "Pense à garder les photos à jour pour une reconnaissance rapide sur mobile.",
    ],
    mobileTips: [
      "Sur smartphone, privilégiez la recherche directe par nom.",
      "Touchez la photo pour entrer rapidement dans la fiche adhérent.",
    ],
  },
  {
    id: "appel-presence",
    title: "Appel Présence",
    category: "Présences",
    icon: FaClipboardCheck,
    color: "from-emerald-500 to-teal-500",
    shortDescription:
      "Faire l’appel du cours rapidement, en choisissant d’abord un groupe puis en basculant Présent / Absent / Non saisi sur chaque carte.",
    searchTags: [
      "présence",
      "appel",
      "absent",
      "présent",
      "cours",
      "groupe",
      "assiduité",
      "dojo",
    ],
    steps: [
      "Choisissez d’abord le groupe concerné par l’appel.",
      "La liste des adhérents du groupe s’affiche sous forme de cartes.",
      "Touchez une carte pour faire défiler les états : Non saisi → Présent → Absent → Non saisi.",
      "L’enregistrement se fait immédiatement après chaque action.",
    ],
    quickActions: [
      "Choisir un groupe actif",
      "Faire l’appel sur smartphone",
      "Voir les anniversaires du jour",
      "Repérer l’assiduité de chaque élève",
    ],
    tips: [
      "L’appel mobile doit être pensé pour aller vite : groupe d’abord, cartes ensuite.",
      "Le tri par assiduité peut être utile pour repérer les élèves réguliers ou décrocheurs.",
      "Les badges blessure et anniversaire aident à contextualiser la séance.",
    ],
    mobileTips: [
      "Sur téléphone, l’écran d’accueil doit afficher immédiatement les groupes actifs.",
      "Évite les menus déroulants longs : un choix visuel des groupes est plus rapide.",
    ],
  },
  {
    id: "tableau-appel",
    title: "Tableau Appel",
    category: "Présences",
    icon: FaTable,
    color: "from-fuchsia-500 to-violet-500",
    shortDescription:
      "Analyser les présences d’un groupe sur un mois, sous forme de tableau/heatmap, avec modification directe des cases.",
    searchTags: [
      "tableau",
      "présences",
      "heatmap",
      "mois",
      "assiduité",
      "absences",
      "groupe",
    ],
    steps: [
      "Sélectionnez d’abord le groupe concerné.",
      "Choisissez ensuite le mois à analyser.",
      "Le tableau affiche chaque adhérent avec les jours du mois.",
      "Touchez une case pour basculer Présent → Absent → Non saisi.",
    ],
    quickActions: [
      "Comparer les assiduités",
      "Corriger une présence oubliée",
      "Voir le taux de présence mensuel",
      "Afficher les graphiques du groupe",
    ],
    tips: [
      "La visualisation mensuelle aide à détecter les absences répétées.",
      "Le top assiduité du mois met en avant les pratiquants les plus réguliers.",
      "Les graphiques offrent une bonne synthèse au responsable de section ou à l’enseignant.",
    ],
    mobileTips: [
      "Sur mobile, il est préférable de choisir le groupe avant d’afficher le tableau.",
      "Le scroll horizontal doit être fluide et lisible, avec nom/prénom figés si possible.",
    ],
  },
  {
    id: "passage-ceinture",
    title: "Passage Ceinture",
    category: "Grades",
    icon: FaAward,
    color: "from-amber-500 to-orange-500",
    shortDescription:
      "Préparer et suivre le passage de ceinture : candidats, validations, observations et progression.",
    searchTags: [
      "ceinture",
      "passage",
      "grade",
      "candidats",
      "progression",
      "validation",
    ],
    steps: [
      "Consultez les adhérents éligibles ou suivis pour un passage.",
      "Vérifiez leur niveau, leur régularité et leur préparation.",
      "Ajoutez vos observations pédagogiques.",
      "Validez ou préparez la prochaine étape du passage.",
    ],
    quickActions: [
      "Voir les candidats",
      "Suivre la progression",
      "Ajouter une observation",
      "Préparer une séance ciblée",
    ],
    tips: [
      "Regrouper cette page avec les techniques et la présence donne une vision plus juste du niveau.",
      "Les observations courtes sont souvent plus efficaces que de longues notes peu relues.",
    ],
    mobileTips: [
      "Sur smartphone, afficher d’abord les candidats prioritaires.",
      "Prévoir des actions simples : voir, noter, valider.",
    ],
  },
  {
    id: "grade-cn",
    title: "Grade CN",
    category: "Grades",
    icon: FaMedal,
    color: "from-yellow-500 to-amber-600",
    shortDescription:
      "Suivre les éléments liés au Grade CN, aux validations et à la préparation des candidats.",
    searchTags: [
      "grade cn",
      "cn",
      "uv",
      "dossier",
      "candidat",
      "préparation",
      "grade",
    ],
    steps: [
      "Identifiez les candidats engagés dans une démarche Grade CN.",
      "Suivez leur avancement et les éléments déjà validés.",
      "Ajoutez des notes pour orienter le travail technique ou physique.",
      "Préparez le suivi sur la durée pour ne rien oublier.",
    ],
    quickActions: [
      "Lister les candidats",
      "Suivre les validations",
      "Ajouter des remarques",
      "Préparer un accompagnement",
    ],
    tips: [
      "Le suivi Grade CN doit être régulier : mieux vaut compléter un peu souvent que beaucoup trop tard.",
      "Associer cette page aux techniques et objectifs peut être très utile.",
    ],
    mobileTips: [
      "Affiche les informations essentielles en premier : nom, niveau, état d’avancement.",
    ],
  },
  {
    id: "prepa-physique",
    title: "Prépa Physique Coaching",
    category: "Préparation",
    icon: FaDumbbell,
    color: "from-slate-700 to-slate-900",
    shortDescription:
      "Créer des exercices, constituer des programmes et affecter des exercices à un ou plusieurs adhérents.",
    searchTags: [
      "préparation physique",
      "coaching",
      "exercices",
      "programme",
      "répétitions",
      "assignation",
      "groupe",
      "catégorie",
    ],
    steps: [
      "Créez d’abord vos exercices dans l’onglet de gestion des exercices.",
      "Ajoutez ensuite des affectations à un adhérent ou à un lot d’adhérents.",
      "Filtrez selon le groupe, la catégorie d’âge ou d’autres critères.",
      "Suivez ensuite le statut fait / non fait et les répétitions.",
    ],
    quickActions: [
      "Créer un exercice",
      "Assigner à un groupe",
      "Assigner par catégorie d’âge",
      "Suivre l’exécution",
    ],
    tips: [
      "Séparer la bibliothèque d’exercices et les affectations est une très bonne logique.",
      "L’assignation par lot est idéale pour faire gagner du temps.",
      "Ajoute des intitulés d’exercices très clairs pour faciliter la recherche.",
    ],
    mobileTips: [
      "Sur mobile, la partie affectation doit proposer des filtres simples et rapides.",
      "Utilise des tableaux scrollables plutôt que trop de cartes si la liste devient longue.",
    ],
  },
  {
    id: "suivi-competitions",
    title: "Suivi Compétitions",
    category: "Compétitions",
    icon: FaTrophy,
    color: "from-rose-500 to-red-500",
    shortDescription:
      "Gérer les inscrits aux compétitions, inscrire/désinscrire, saisir les résultats et mettre à jour le palmarès.",
    searchTags: [
      "compétition",
      "inscription",
      "désinscription",
      "résultats",
      "palmarès",
      "classement",
      "pesée",
      "année de naissance",
    ],
    steps: [
      "Choisissez l’événement concerné.",
      "Dépliez la carte pour voir les inscrits.",
      "Inscrivez ou désinscrivez les adhérents selon les filtres disponibles.",
      "Touchez la photo d’un inscrit pour ouvrir la saisie de résultats.",
    ],
    quickActions: [
      "Filtrer les compétitions",
      "Inscrire des adhérents",
      "Filtrer par catégorie d’âge et année de naissance",
      "Saisir les résultats",
      "Mettre à jour le palmarès",
    ],
    tips: [
      "L’année de naissance est très utile en judo pour préparer les pesées et les catégories.",
      "La photo cliquable est le meilleur point d’entrée pour la saisie des résultats.",
      "Toujours penser au palmarès après l’enregistrement des résultats.",
    ],
    mobileTips: [
      "Sur téléphone, les filtres doivent être très accessibles dans le drawer d’inscription.",
      "Les cartes inscrits doivent rester visuelles, sans surcharge d’actions.",
    ],
  },
  {
    id: "evenements",
    title: "Événements",
    category: "Organisation",
    icon: FaCalendarAlt,
    color: "from-cyan-500 to-blue-500",
    shortDescription:
      "Consulter les événements du club et repérer rapidement les actions ou rendez-vous liés à l’activité enseignant.",
    searchTags: [
      "événement",
      "agenda",
      "stage",
      "animation",
      "tournoi",
      "calendrier",
    ],
    steps: [
      "Parcourez le calendrier des événements.",
      "Identifiez les événements utiles pour votre groupe ou vos compétiteurs.",
      "Vérifiez les détails pratiques : date, lieu, type, niveau.",
      "Basculez ensuite vers le suivi compétition si l’événement gère des inscrits.",
    ],
    quickActions: [
      "Voir les événements à venir",
      "Consulter les détails",
      "Préparer les inscrits",
    ],
    tips: [
      "Cette page sert de porte d’entrée agenda avant l’inscription compétition.",
    ],
    mobileTips: [
      "Affiche d’abord les événements à venir, avec les informations clés visibles immédiatement.",
    ],
  },
  {
    id: "palmares",
    title: "Palmarès",
    category: "Compétitions",
    icon: FaStar,
    color: "from-yellow-400 to-orange-500",
    shortDescription:
      "Conserver l’historique des résultats des adhérents et valoriser leur parcours sportif.",
    searchTags: [
      "palmarès",
      "résultats",
      "historique",
      "compétition",
      "médailles",
      "classement",
    ],
    steps: [
      "Consultez le palmarès des adhérents.",
      "Ajoutez ou mettez à jour les résultats après les compétitions.",
      "Utilisez cette page pour visualiser la progression compétitive d’un athlète.",
    ],
    quickActions: [
      "Consulter un historique",
      "Ajouter un résultat",
      "Mettre à jour un résultat",
    ],
    tips: [
      "Le palmarès est précieux pour préparer les bilans sportifs et valoriser les compétiteurs.",
    ],
    mobileTips: [
      "Sur smartphone, prévoir un accès direct à l’historique d’un compétiteur.",
    ],
  },
  {
    id: "objectifs",
    title: "Objectifs",
    category: "Organisation",
    icon: FaBullseye,
    color: "from-lime-500 to-emerald-500",
    shortDescription:
      "Définir et suivre les objectifs individuels ou de groupe sur le plan technique, physique ou compétitif.",
    searchTags: [
      "objectifs",
      "suivi",
      "progression",
      "performance",
      "plan",
      "travail",
    ],
    steps: [
      "Créez des objectifs clairs pour un adhérent ou un groupe.",
      "Assurez un suivi régulier avec des points d’étape.",
      "Faites le lien avec la présence, la prépa physique et la compétition.",
    ],
    quickActions: [
      "Créer un objectif",
      "Suivre la progression",
      "Prioriser le travail",
    ],
    tips: [
      "Des objectifs simples, concrets et mesurables sont souvent les plus efficaces.",
    ],
    mobileTips: [
      "Sur téléphone, mets en avant les objectifs prioritaires du moment.",
    ],
  },
  {
    id: "todolist",
    title: "ToDoList",
    category: "Organisation",
    icon: FaTasks,
    color: "from-indigo-500 to-purple-500",
    shortDescription:
      "Retrouver les tâches à faire et ne rien oublier dans le suivi du quotidien enseignant.",
    searchTags: [
      "todo",
      "tâches",
      "rappel",
      "organisation",
      "liste",
      "à faire",
    ],
    steps: [
      "Consultez les tâches en cours.",
      "Ajoutez les rappels utiles au fonctionnement enseignant.",
      "Cochez ou mettez à jour les tâches au fur et à mesure.",
    ],
    quickActions: [
      "Créer une tâche",
      "Suivre les urgences",
      "Organiser sa semaine",
    ],
    tips: [
      "Une ToDoList courte et priorisée est beaucoup plus utile qu’une très longue liste.",
    ],
    mobileTips: [
      "Sur mobile, privilégier une vue rapide avec les tâches prioritaires en haut.",
    ],
  },
  {
    id: "techniques-enseignants",
    title: "Techniques Enseignants",
    category: "Ressources",
    icon: FaBookOpen,
    color: "from-blue-600 to-indigo-700",
    shortDescription:
      "Retrouver des contenus techniques, supports pédagogiques et ressources utiles à l’enseignement.",
    searchTags: [
      "techniques",
      "enseignants",
      "pédagogie",
      "supports",
      "cours",
      "judo",
      "ressources",
    ],
    steps: [
      "Parcourez les contenus techniques disponibles.",
      "Sélectionnez les ressources pertinentes pour votre séance ou votre public.",
      "Utilisez-les en appui de votre préparation pédagogique.",
    ],
    quickActions: [
      "Voir une ressource",
      "Préparer un cours",
      "Réviser une technique",
    ],
    tips: [
      "Cette page peut servir de base pour préparer les cours ou les passages de grades.",
    ],
    mobileTips: [
      "Sur smartphone, afficher les ressources les plus consultées ou les dernières utilisées.",
    ],
  },
  {
    id: "categories",
    title: "Catégories",
    category: "Ressources",
    icon: FaBalanceScale,
    color: "from-slate-500 to-slate-700",
    shortDescription:
      "Consulter les catégories d’âge et de poids pour mieux préparer compétitions, pesées et suivi sportif.",
    searchTags: [
      "catégories",
      "âge",
      "poids",
      "judo",
      "compétition",
      "année de naissance",
      "pesée",
    ],
    steps: [
      "Consultez les catégories d’âge selon la saison.",
      "Vérifiez les catégories de poids en fonction du genre et du poids saisi.",
      "Utilisez ces informations avant les compétitions ou les regroupements.",
    ],
    quickActions: [
      "Vérifier une catégorie d’âge",
      "Vérifier une catégorie de poids",
      "Préparer une pesée",
    ],
    tips: [
      "Cette page est particulièrement utile avant les compétitions et les inscriptions.",
    ],
    mobileTips: [
      "Sur mobile, afficher d’abord les informations les plus fréquentes : âge, année de naissance, poids.",
    ],
  },
];